import { getAllWorkTeams } from "../../../services/workTeam/workTEam";
import {
  handleCatchErrors,
  responseDataFormatRedux,
} from "../../../middlewares/resolveRequests";
import * as actionTypes from "../../actions/actionTypes";

export const getAllWorkTeamsAPI = async (
  communityId,
  pageNumber = 1,
  pageSize = 100,
  token
) => {
  let response;
  try {
    response = await getAllWorkTeams(communityId, pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_WORK_TEAMS);
  }
};
export const clearAllWorkTeamsAPI = () => {
  return responseDataFormatRedux({ data: null }, actionTypes.GET_WORK_TEAMS);
};
